import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Building2 } from "lucide-react";

// TODO(Phase 5B): Full District Franchise onboarding — operator KYC, unit
// linking (School + Store + Academies), agreement e-sign, consolidated billing.
// This is a MINIMAL placeholder that only surfaces the Plan Selection dropdown
// wired to the live `franchise_plans` (membership) collection.
export default function FranchiseOnboard() {
  const [plans, setPlans] = useState([]);
  const [planKey, setPlanKey] = useState("");

  useEffect(() => {
    api.get("/membership/plans/franchise").then(r => {
      setPlans(r.data);
      if (r.data[0]) setPlanKey(r.data[0].key);
    }).catch(() => {});
  }, []);

  const selected = plans.find(p => p.key === planKey);

  return (
    <div className="min-h-screen bg-[#FAF7F0] p-4 md:p-8" data-testid="franchise-onboard">
      <div className="max-w-xl mx-auto space-y-6">
        <div className="flex items-center gap-2">
          <Building2 size={28} />
          <h1 className="display text-3xl font-black">District Franchise</h1>
        </div>
        <div className="nb-card bg-[#FDE047] p-4 border-2 border-black text-sm">
          <b>Preview:</b> full franchise onboarding is coming in a future phase. For now, choose the franchise plan you're interested in — our team will reach out to complete the cluster agreement.
        </div>
        <div className="nb-card bg-white p-6 space-y-3 border-2 border-black">
          <label className="nb-label">Select Franchise Plan</label>
          <select className="nb-select" value={planKey} onChange={e => setPlanKey(e.target.value)} data-testid="franchise-plan">
            {plans.map(p => (
              <option key={p.key} value={p.key}>
                {p.name} — ₹{Number(p.effective_price ?? p.base_price).toLocaleString()}/{p.billing_interval === "monthly" ? "mo" : "yr"}
              </option>
            ))}
          </select>
          {selected?.features?.length > 0 && (
            <ul className="text-xs mt-1 space-y-0.5" data-testid="franchise-plan-features">
              {selected.features.map((x, i) => <li key={i}>✓ {x}</li>)}
            </ul>
          )}
          <button className="nb-btn w-full justify-center opacity-60 cursor-not-allowed" disabled
            title="Full franchise onboarding launches in a future phase" data-testid="franchise-submit">
            Request Franchise (coming soon)
          </button>
          <Link to="/" className="text-xs underline block text-center">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
